import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <section id="contactos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            {t('contactTitle')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('contactSubtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-6">{t('contactTitle')}</h3>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-900">{t('phone')}</h4>
                  <p className="text-gray-600">+351 937 545 000</p>
                  <p className="text-xs text-gray-500 mt-1">(Custo de uma chamada para a rede móvel nacional)</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-900">{t('email')}</h4>
                  <p className="text-gray-600">geral@farways.pt</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-900">{t('address')}</h4>
                  <p className="text-gray-600">
                    Rua João de Deus, 28C<br />
                    8000-368 Faro, Portugal
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-white text-xl"></i>
                </div>
                <div className="ml-4">
                  <h4 className="text-lg font-semibold text-gray-900">{t('schedule')}</h4>
                  <p className="text-gray-600 whitespace-pre-line">{t('scheduleText')}</p>
                </div>
              </div>

              <div className="bg-orange-50 p-4 rounded-lg mt-6">
                <p className="text-sm text-gray-700">
                  <strong>FARWAYS</strong> - Marca registada de Alves e Frade, Lda.<br />
                  NIPC: 505413850 | RNAVT: 8586
                </p>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg mt-4 space-y-3">
                <a 
                  href="https://www.livroreclamacoes.pt/Inicio/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  <i className="ri-file-list-3-line text-xl mr-3"></i>
                  <div>
                    <p className="font-semibold">
                      {currentLang === 'pt' ? 'Livro de Reclamações Online' : currentLang === 'es' ? 'Libro de Reclamaciones Online' : 'Online Complaints Book'}
                    </p>
                    <p className="text-sm text-gray-600">www.livroreclamacoes.pt</p>
                  </div>
                </a>
                
                <a 
                  href="https://consumoalgarve.pt/index.php/pt/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center text-gray-700 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  <i className="ri-scales-3-line text-xl mr-3"></i>
                  <div>
                    <p className="font-semibold">
                      {currentLang === 'pt' ? 'Centro de Arbitragem de Consumo do Algarve' : currentLang === 'es' ? 'Centro de Arbitraje de Consumo del Algarve' : 'Algarve Consumer Arbitration Center'}
                    </p>
                    <p className="text-sm text-gray-600">consumoalgarve.pt</p>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-6">
              {t('formTitle')}
            </h3>
            <form 
              className="space-y-6" 
              data-readdy-form
              action="https://readdy.ai/api/form/d46rnibq5e24j8uscv3g"
              method="POST"
              onSubmit={(e) => {
                e.preventDefault();
                const formData = new FormData(e.target as HTMLFormElement);
                fetch('https://readdy.ai/api/form/d46rnibq5e24j8uscv3g', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: new URLSearchParams(formData as any).toString()
                }).then(() => {
                  alert(t('successMessage'));
                  (e.target as HTMLFormElement).reset();
                }).catch(() => {
                  alert(t('errorMessage'));
                });
              }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t('nameLabel')}
                  </label>
                  <input
                    type="text"
                    name="nome"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder={t('namePlaceholder')}
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {t('email')}
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    placeholder={t('emailPlaceholder')}
                    required
                  />
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  {t('phoneLabel')}
                </label>
                <input
                  type="tel"
                  name="telefone"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder={t('phonePlaceholder')}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  {t('subjectLabel')}
                </label>
                <input
                  type="text"
                  name="assunto"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder={t('subjectPlaceholder')}
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  {t('messageLabel')}
                </label>
                <textarea
                  rows={5}
                  name="mensagem"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                  placeholder={t('messagePlaceholder')}
                  maxLength={500}
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
              >
                {t('submitButton')}
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.123456789!2d-7.9304!3d37.0194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sFaro%20Airport!5e0!3m2!1sen!2spt!4v1234567890"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização FARWAYS VIAGENS"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
